import _ from 'lodash';
import React, {FunctionComponent} from 'react';
import {getAmountUomString} from '@treez-ui/core/lib/product';
import {ProductInCatalog} from '@treez/commons/sharedTypings/product';
import {TableCell, TableRow} from '@material-ui/core';
import {PRODUCT_TABLE_FIELDS, TableFieldOptions, tableFields} from '../CatalogAssignment';

interface Props {
    productToRender: Partial<ProductInCatalog>;
    key: string;
}

export const ProductInfoRow: FunctionComponent<Props> = (props) => {
    const {productToRender, key} = props;

    return (
        <TableRow key={key}>
            {_.map(PRODUCT_TABLE_FIELDS, (field, idx) => {
                const headerAttributes = tableFields[field];

                const {dataField} = headerAttributes;

                let value = _.get(productToRender, dataField!, '');
                if (TableFieldOptions.AMOUNT === field) {
                    const uom = _.get(productToRender, 'uom');

                    value = getAmountUomString(Number(value), uom);
                }

                return (
                    <TableCell key={productToRender.id + field + idx}>
                        <div className="product-info-text-wrapper">{value}</div>
                    </TableCell>
                );
            })}
        </TableRow>
    );
};

export default ProductInfoRow;
